import {NavLink} from "react-router-dom";
import React, { Fragment } from "react";

const GuestNav = () => (
  <Fragment>
  <div className="flex flex-col lg:flex-row gap-2">
    <NavLink
      to="/"
      exact
      className="nav-link hover:bg-neutral-100"
      activeClassName="router-link-exact-active"
    >
      Home
    </NavLink>
    <NavLink
      to="/about-us"
      exact
      className="nav-link hover:bg-neutral-100"
      activeClassName="router-link-exact-active"
    >
      About Us
    </NavLink>
    <NavLink
      to="/support"
      exact
      className="nav-link hover:bg-neutral-100"
      activeClassName="router-link-exact-active"
    >
      Support
    </NavLink>
    <NavLink
      to="/sign-up"
      exact
      className="nav-link hover:bg-neutral-100"
      activeClassName="router-link-exact-active"
    >
      Signing Agent / Field Inspector Sign Up
    </NavLink>
  </div>
  </Fragment>
);

export default GuestNav;
